import { notification } from "antd";
import { useTranslation } from "react-i18next";

import { useCreateAutocategorizationRuleMutation } from "../../../api/graphql/mutations/autocategorizationRule";
import { IMessageType } from "../../../types";
import { showMessage } from "../../../utils";
import { getServerErrorNotification } from "../../../utils/error";
import { ContentWrapper } from "../../common/styledComponents";
import RuleForm from "./RuleForm";
import { FormHeading } from "./styledComponents";

export const AddRule = () => {
  const { t } = useTranslation("Rules");
  const [createRule, createRuleResult] =
    useCreateAutocategorizationRuleMutation({
      onCompleted: () => {
        showMessage({
          type: IMessageType.SUCCESS,
          duration: 3,
          content: t("page.saved"),
        });
        window.opener?.location.reload();
        window.close();
      },
      onError: (error) => {
        notification.error(
          getServerErrorNotification(error, t("page.createError"))
        );
      },
    });

  return (
    <ContentWrapper padding="0">
      <RuleForm
        title={<FormHeading>{t("page.addTitle")}</FormHeading>}
        loading={createRuleResult.loading}
        onSubmit={(rule) => {
          createRule({
            variables: {
              input: rule,
            },
          });
        }}
      />
    </ContentWrapper>
  );
};
